import prependBasePath from './prependBasePath';

export default prependBasePath;
